import React from 'react';

const Visa = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={60} height={40} fill="none" {...props}>
    <path fill="#F7F7F7" d="M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z" />
    <path
      fill="#3362AB"
      d="M51.638 12.544h-3.143c-.95 0-1.681.292-2.12 1.242l-5.994 13.67h4.24s.73-1.828.877-2.266h5.19c.146.512.512 2.193.512 2.193H55l-3.362-14.84Zm-4.97 9.576c.365-.878 1.608-4.167 1.608-4.167 0 .073.365-.877.511-1.389l.293 1.316s.804 3.582.95 4.313h-3.363v-.073ZM40.672 22.559c0 3.07-2.778 5.117-7.091 5.117-1.828 0-3.582-.366-4.532-.804l.585-3.363.511.22c1.316.584 2.193.803 3.802.803 1.17 0 2.412-.438 2.412-1.462 0-.658-.512-1.096-2.12-1.827-1.535-.731-3.582-1.9-3.582-4.02 0-2.925 2.85-4.898 6.871-4.898 1.535 0 2.851.292 3.655.658l-.584 3.216-.293-.292c-.73-.293-1.681-.585-3.07-.585-1.535.073-2.266.73-2.266 1.316 0 .657.877 1.17 2.266 1.827 2.34 1.096 3.436 2.34 3.436 4.094Z"
    />
    <path
      fill="#F9B50B"
      d="m5 12.69.073-.292h6.286c.877 0 1.535.292 1.755 1.243l1.388 6.579C13.113 16.71 9.897 13.86 5 12.69Z"
    />
    <path
      fill="#3362AB"
      d="m23.346 12.544-6.36 14.839h-4.312L9.019 14.956c2.632 1.681 4.825 4.313 5.629 6.14l.438 1.535 3.948-10.16h4.313v.073ZM25.03 12.47h4.02L26.49 27.384h-4.02l2.558-14.912Z"
    />
  </svg>
);

export default Visa;
